import { Box, Grid, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";

export const MotionBox = motion.create(Box, { forwardMotionProps: true });
export const MotionText = motion.create(Text, { forwardMotionProps: true });
export const MotionGrid = motion.create(Grid, { forwardMotionProps: true });
